// data.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function data(apiData = [], onEdit) {
  return {
    columns: [
      { Header: "Customer Name", accessor: "customer", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "Community Name", accessor: "title", align: "left" },
      { Header: "Mobile No", accessor: "mobileNumber", align: "left" },
      // { Header: "Active", accessor: "isactive", align: "center" },
      // { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      customer: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.customerName ?? "-"}
        </MDTypography>
      ),
      email: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.customerEmail ?? "-"}
        </MDTypography>
      ),
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.communityname ?? "-"}
        </MDTypography>
      ),
      mobileNumber: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.mobileNumber ?? "-"}
        </MDTypography>
      ),
      isactive: (
        <MDBox display="flex" justifyContent="center">
          <MDTypography
            variant="caption"
            fontWeight="medium"
            color={item.isactive ? "success" : "error"}
          >
            {item.isactive ? "Yes" : "No"}
          </MDTypography>
        </MDBox>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="info"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item);
          }}
        >
          Edit
        </MDTypography>
      ),
    })),
  };
}
